export const QUESTION_CREATION_TRANSLATE = {
  ADD_OTHER_OPTION: "回答（記述式）を追加",
  ADD_NEW_OPTION: "回答（選択肢）を追加",
  SET_REQUIRED: "必須回答",
  REQUIRED_QUESTION_NAME: "質問内容を入力してください。",
};
